import CallRoundedIcon from '@mui/icons-material/CallRounded';
import CloseIcon from '@mui/icons-material/Close';
// import StarIcon from '@mui/icons-material/Star';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Box,
  Button,
  DialogActions,
  Stack,
  // List,
  // ListItem,
  // ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import useClipboard from 'react-use-clipboard';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const DeadlinePopup = () => {
  const [open, setOpen] = useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };

  const [isCopied, setCopied] = useClipboard('EFILE2290', {
    successDuration: 6000,
  });

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="holiday-theme"
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      />
      <DialogContent>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 0, sm: 2, md: 3 }}
            alignItems="center"
            justifyContent="space-around"
            sx={{ px: { xs: 0, sm: 2 } }}
          >
            <Box sx={{ textAlign: { xs: 'center', sm: 'center' } }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 24, sm: 28, md: 30 },
                  mb: 1,
                  color: '#333',
                  lineHeight: 1.2,
                }}
              >
                Wait! You're Missing Out on{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: 20, sm: 22, md: 30 },
                    color: '#da4b4b',
                  }}
                >
                  10% Off
                </Box>{' '}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: { xs: 19, sm: 20, md: 20 },
                  mb: 3,
                  lineHeight: 1.3,
                }}
              >
                File Form 2290 with confidence, avoid IRS penalties, and get
                expert support when you need it.
              </Typography>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                sx={{
                  background:
                    'radial-gradient(circle,rgba(255, 243, 224, 1) 0%, rgba(255, 243, 214, 1) 50%)',
                  border: '2px dashed #1d1d1d',
                  borderRadius: 3,
                  // p: 2,
                  mb: 3,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignContent: 'left',
                    justifyContent: 'center',
                    borderRight: { md: '2px dashed #333', xs: 'none' },
                    textAlign: 'left',
                    p: 2,
                    gap: 1,
                  }}
                >
                  <picture>
                    <img
                      src="/assets/images/clock-icon.png"
                      loading="lazy"
                      alt="Wait! You're Missing Out on"
                      className="tab-responsive"
                      width={80}
                      height={95}
                    />
                  </picture>{' '}
                  <Box
                    sx={{
                      alignContent: 'center',
                      justifyContent: 'center',
                      textAlign: 'left',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 17, sm: 16, xs: 13 },
                        mb: 0,
                        fontWeight: 600,
                        color: '#fff',

                        '&': {
                          '--r': '0.8em',
                          px: '18px',
                          paddindInline: 'calc(var(--r) + .4em)',
                          lineHeight: 1.8,
                          clipPath:
                            'polygon(0 0,100% 0,calc(100% - var(--r)) 50%,100% 100%,0 100%, var(--r) 50%)',
                          background: ' #CC333F',
                          width: 'fit-content',
                        },
                      }}
                    >
                      Limited-Time Offer
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 48, sm: 36, xs: 30 },
                        mb: 0,
                        fontWeight: 700,
                      }}
                    >
                      10% OFF
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ textAlign: 'left' }}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: 28, sm: 20, md: 20 },
                      mb: 1,
                      lineHeight: 1.3,
                    }}
                  >
                    Use Code
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: 28, sm: 20, md: 20 },
                      mb: 0,
                      lineHeight: 1.3,
                    }}
                  >
                    <Box
                      component="strong"
                      sx={{
                        ml: 0,
                        color: '#1da94a',
                        fontWeight: 600,
                        border: '2px dashed rgb(113, 81, 0)',
                        px: 1,
                        py: 0.8,
                        backgroundColor: '#fff',
                      }}
                    >
                      {' '}
                      EFILE2290
                      <Tooltip
                        title={isCopied ? 'Copied' : 'Copy to Clipboard'}
                        arrow
                      >
                        <IconButton
                          onClick={setCopied}
                          sx={{ mt: '-6px !important' }}
                        >
                          <ContentCopyIcon sx={{ fontSize: 22 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>{' '}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 6 }}
            sx={{
              borderTop: '1px solid #ccc',
              pt: 3,
              textAlign: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              p: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',

                gap: 1.2,
                width: '50%',
              }}
            >
              <picture>
                <img
                  src="/assets/images/irs-icon.png"
                  loading="lazy"
                  alt="Receive IRS Stamped"
                  className="tab-responsive"
                  width={50}
                  height={50}
                />
              </picture>{' '}
              <Box>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 15 },
                    fontWeight: 600,
                    my: 0,
                    textAlign: 'left',
                    maxWidth: 600,
                    mx: 'auto',
                  }}
                >
                  Receive IRS Stamped
                </Typography>
                <Typography variant="body2" sx={{ textAlign: 'left' }}>
                  Schedule 1 In Minutes
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                width: '50%',
                gap: 1.2,
              }}
            >
              <picture>
                <img
                  src="/assets/images/support-icon.png"
                  loading="lazy"
                  alt="US-Based Expert Support"
                  className="tab-responsive"
                  width={50}
                  height={50}
                />
              </picture>{' '}
              <Box>
                <Typography
                  // component="div"
                  variant="body1"
                  sx={{
                    fontSize: { xs: 16, sm: 17, md: 15 },
                    fontWeight: 600,
                    my: 0,
                    textAlign: 'left',
                    maxWidth: 600,
                    mx: 'auto',
                  }}
                >
                  US-Based Expert Support
                </Typography>
                <Typography variant="body2" sx={{ textAlign: 'left' }}>
                  (English & Spanish)
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          pt: '16px !important',
          pb: '24px !important',
          textAlign: 'center',
          background: '#f5f5f5',
          borderTop: '1px solid #ccc',
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Box sx={{ px: { xs: 1, sm: 3 } }}>
            {/* <Typography
            variant="body1"
            sx={{
              fontSize: { xs: 13, sm: 14 },
              fontWeight: 500,
              mb: 1,
              fontStyle: 'italic',
            }}
          >
            File Now—Don&apos;t miss out!
          </Typography> */}
            <Button
              variant="contained"
              // size="large"
              // className="btn-primary"
              sx={{
                textTransform: 'none',
                display: 'inline-block',

                boxShadow: 'none',
                borderRadius: '16px !important',
                fontSize: 20,
                px: 1.8,
                py: 1.2,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': {
                  transform: 'scale(1.1)',
                  boxShadow: 'none',
                },
              }}
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=2290exitpopup`}
            >
              E-File Now & Save 10%
            </Button>
          </Box>
          <Box sx={{ px: { xs: 1, sm: 3 } }}>
            <Button
              onClick={() => window.open('tel:+14084447120', '_self')}
              variant="contained"
              // size="small"
              // className="btn-secondary"
              sx={{
                textTransform: 'none',
                display: 'inline-block',
                boxShadow: 'none',
                borderRadius: '16px !important',
                backgroundColor: '#1da94a',
                fontSize: 20,
                px: 1.8,
                py: 1.2,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': {
                  transform: 'scale(1.1)',
                  boxShadow: 'none',
                },
              }}
            >
              <CallRoundedIcon sx={{ mb: -0.5 }} /> (408) 444-7120
            </Button>
          </Box>
        </Stack>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default DeadlinePopup;
